// extracted by mini-css-extract-plugin
export default {"thirdLevelTitle":"ff-mobile-header-menu-third-level-item_thirdLevelTitle__AzAiB"};